<template>
    <div>
        <div class="bg-white pb-6"  style="border-bottom-left-radius: 5px; border-bottom-right-radius: 5px; height: auto;">
            <div v-if="ajaxCallInProgress" class="d-flex align-items-center justify-content-center w-100 pt-10">
                <half-circle-spinner :animation-duration="1000" :size="40" color="#00448b" style="margin: 0 auto;" />
            </div>
            <div v-else>
                <div class="fs-14 fw-500 px-6 bg-color py-2 mb-6">Meeting Info</div>
                <div class="table-div mt-4 mx-4 p-4">
                    <div  class="d-flex justify-content-between align-items-center py-2 px-4">
                        <div>
                            <span class="text-secondary fw-600 fs-14">Meeting Details: </span>
                            <div class="pt-3"><span class="fw-500">Title of the Meeting:</span><span> {{meeting_details.meeting_title}}</span></div>
                        </div>
                        <div>
                            <div class="calendar-custom text-center position-relative">
                                <div class="calendar-holder" style="left: 15%"></div>
                                <div class="calendar-holder" style="right: 15%"></div>
                                <div class="text-white" style="border-bottom:2px solid #abc1e5;">{{meeting_details.month}}</div>
                                <div class="text-white fs-15 fw-600">{{meeting_details.day}}</div>
                            </div>
                        </div>
                    </div>
                    <div  class="px-4">
                        <div class="pt-1"><span class="fw-500">Counterparty:</span><span> {{customer_details.customer_name}}</span></div>
                        <div class="pt-3"><span class="fw-500">Meeting Time:</span><span> {{meeting_details.start_date}} {{meeting_details.start_time}} - {{meeting_details.end_date}} {{meeting_details.end_time}}</span></div>
                        <div class="pt-3"><div class="fw-500">Invitees:</div>
                            <div class="pt-2 pl-2 d-inline-flex" v-for="(invite, index) in meeting_details.invitees">
                                <span class="invitees-box px-3 py-1 mt-1" style="white-space: pre-wrap;word-wrap: break-word;">{{invite.email}}</span>
                            </div>
                        </div>
                        <div class="pt-3"><div class="fw-500">Other Invitees:</div>
                            <div class="pt-2 pl-2 d-inline-flex" v-for="(other_invite, index) in meeting_details.other_invitees">
                                <span class="invitees-box px-3 py-1 mt-1">{{other_invite}}</span>
                            </div>
                        </div>
                        <div class="pt-3"><span class="fw-500">Description:</span><span style="white-space: pre-wrap;word-wrap: break-word;"> {{meeting_details.description || "-"}}</span></div>
                        <div class="pt-3"><span class="fw-500">Meeting Agenda Details:</span></div>
                        <div class="mt-4" v-for="(table, table_index) in table_details" :key="table_index">
                            <div>
                                <div class="table-name-section mt-4">
                                    <input type="text" autocomplete="off" v-validate="'required'" :name="'table_name'+table_index" class="table-input-field" style="border-bottom: 0px solid #ffff !important;padding: 10px 16px 4px 10px !important;" v-model="table.table_name" placeholder="Enter Table Name" disabled/>
                                </div>
                                <div style="overflow: auto;">
                                    <table class="meeting-data-table mt-4 mb-4" style="width: 100% !important;text-align: left;">
                                        <thead style="width: 100% !important">
                                            <tr>
                                                <th v-for="(headingName, head_index) in table.header_data" :key="head_index"
                                                    style="height: 38px;">
                                                    <input disabled type="text" class="input-border fw-600 fs-14" :name="'table_data'+table_index" v-validate="'required'" v-model="table.header_data[head_index]" placeholder="Enter Heading" />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row,row_index) in table.table_data"
                                                :key="row_index">
                                                <td style="height: 38px;" class="pl-7" v-for="(col_data, col_index) in table.header_data" :key="col_index">
                                                    <input disabled type="text" :name="'table_data'+table_index" v-validate="'required'" class="table-list" v-model="row[col_data]" placeholder="Enter Data"/>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import schedule from "../mixins/scheduleMeeting.js"
import { HalfCircleSpinner } from "epic-spinners";
export default ({
    props: [],
    mixins: [schedule],
    components: {
        HalfCircleSpinner,
    },
    data() {
        return {
            meeting_details: [],
            customer_details:[],
            table_details: [],
            ajaxCallInProgress: false
        }
    },
    methods:{
        async getMeetingData(){
            this.ajaxCallInProgress = true
            let params = {
                id: this.$route.params.id
            }
            let response = await this.getScheduleMeetingById(params)
            this.meeting_details = response.response
            if(this.meeting_details.customer_details != []){
                this.customer_details = this.meeting_details.customer_details
            }else{
                this.meeting_details.customer_details.customer_name = ""
            }
            let agenda_info = this.meeting_details.agenda_info
            if(this.meeting_details.table_details != []){
                this.table_details = agenda_info.table_details
            }else{
                agenda_info.table_details = ""
            }
            this.ajaxCallInProgress = false
        }
    },
    mounted(){
        this.getMeetingData();
    },
})
</script>
<style>
    .bg-color{
        background-color: #00448b;
        color:#fff !important;
        border-radius: 4px;
    }
    .table-div{
        border: 1px solid #00448b;
        border-radius: 5px;
        height: auto;
    }
    .calendar-custom{
        height:50px;
        width:50px;
        background-color: #08448b;
        border:2px solid #abc1e5;
        border-radius:6px;
        margin:auto
    }
    .calendar-holder{
        width: 4px;
        height: 11px;
        background-color: rgb(171, 193, 229);
        position: absolute;
        top: -9px;
        border-radius: 10px;
    }
    .invitees-box{
        background-color: #d6d6d6;
        border-radius: 4px;
        color: #000;
        font-size: 12px;
    }
    .meeting-data-table>tbody>tr:first-child td, .meeting-data-table>tbody>tr:first-child td input {
        background: #fff !important;
        color: #303031 !important;
        border-bottom: 0px solid #fff !important;
    }
    .meeting-data-table>tbody>tr:first-child td {
         border-bottom: 0.5px solid #303031 !important;
    }
    .meeting-data-table tbody tr td input {
        font-weight: 600;
        text-align: left !important;
        border-bottom: 0px solid #000 !important;
    }
    .meeting-data-table thead tr th {
        background: #00448b;
        color: #fff;
        padding: 10px 30px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
        border: 1px solid #000 !important;
    }
    .meeting-data-table thead tr th:first-child {
        border-top-left-radius: 5px;
    }
    .meeting-data-table thead tr th:last-child {
        border-top-right-radius: 5px;
    }
    .meeting-data-table>thead>tr>th input {
        background: #00448B !important;
        color: #ffffff !important;
        border-bottom: 0px solid #fff !important;
    }
    .meeting-data-table>tbody>tr:first-child td input::placeholder{
        color: #7b7f83 !important;
    }
    .meeting-data-table tbody tr td {
        border: 0.5px solid rgba(0, 0, 0, 0.35);
    }
    .table-name-section{
        height: 40px !important;
        background-color: #00448b !important;
    }
    .table-input-field {
        border-bottom: 0px solid #fff !important;
        padding: 10px 16px 4px 14px !important;
        margin-left: px !important;
        width: 20% !important;
        color: #fff !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        background-color: #00448b !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/ScheduleMeeting/MeetingInfoTab.vue